"use strict";

define('uikit/modules/tag.input',['underscore', '../elements/input', '../collections/search.results', '../extra/input.change.tracker', '../extra/key.codes', '../channel', '../templates'], function (_, Input, SearchResults, InputChangeTracker, CODES, channel, Templates) {
  function setCaretPosition(elem, caretPos) {
    if (elem != null) {
      if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else {
        if (elem.selectionStart) {
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
        } else {
          elem.focus();
        }
      }
    }
  }
  var TagInput = Input.extend({
    className: Input.prototype.className + ' visual search',
    options: _.extend({}, Input.prototype.options, {
      searchStartCharCode: 64
    }),
    events: _.extend({}, Input.prototype.events, {
      'keyup @ui.input': 'onInputKeyUp',
      'keydown @ui.input': 'onInputKeyDown'
    }),
    initialize: function initialize() {
      Input.prototype.initialize.apply(this, arguments);
      this.resultsView = new SearchResults();
    },
    template: function template() {
      return Input.prototype.template.apply(this, arguments) + '<ui name="resultsView"/>';
    },
    onResultsViewResultSelected: function onResultsViewResultSelected(results, selected) {
      this.insertSelectedText();
      this.stopSearch();
    },
    onResultsViewResultActive: function onResultsViewResultActive() {},
    onBlur: function onBlur() {
      this.stopSearch();
    },
    onInputKeyDown: function onInputKeyDown(ev) {
      var tokens = this.children,
        keyCode = ev.keyCode,
        preInputTextContent = this.getSearchText();
      this._oldTextContent = preInputTextContent;
      if (keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();
      } else if (keyCode === CODES.TAB_KEY && preInputTextContent) {
        ev.preventDefault();
      } else if (keyCode === CODES.TAB_KEY) {} else if (keyCode === CODES.BACKSPACE_KEY && this._isSearching) {
        if (preInputTextContent.length === 0) {
          this.stopSearch();
        }
      } else if (keyCode === CODES.DOWNARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
        this.resultsView.selectNextResult();
      } else if (keyCode === CODES.UPARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
        this.resultsView.selectPreviousResult();
      } else if (keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.stopSearch();
      }
    },
    onInputKeyUp: function onInputKeyUp(ev) {
      var keyCode = ev.keyCode,
        textContent = this.getSearchText();
      if (keyCode === CODES.DOWNARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
      } else if (keyCode === CODES.UPARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
      } else if (keyCode === CODES.ENTER_KEY || keyCode === CODES.TAB_KEY) {
        ev.preventDefault();
        if (!this.isResultsEmpty() && this.resultsView.getSelected()) {
          this.insertSelectedText();
        }
        this.stopSearch();
      } else if (this._isSearching) {
        this.triggerSearchText();
      } else if (keyCode === this.searchStartCharCode) {
        this.startSearch();
        this.triggerSearchText();
      }
    },
    insertSelectedText: function insertSelectedText() {
      var selected = this.resultsView.getSelected(),
        currentText = this.getSearchText(),
        value = this.value == null ? '' : String(this.value),
        text = '';
      if (!this.inputTracker) {
        return;
      }
      if (selected && _.isFunction(this.getOption('textFormatter'))) {
        text = this.getOption('textFormatter').call(this, selected.model);
      } else if (selected) {
        text = selected.text;
      }
      this.value = this.inputTracker.leftValue(1) + text + this.inputTracker.rightValue();
      setCaretPosition(this.ui.input.get(0), this.inputTracker.startIndex + text.length - 1);
    },
    startSearch: function startSearch() {
      this._isSearching = true;
      this.inputTracker = new InputChangeTracker(this.ui.input);
    },
    stopSearch: function stopSearch() {
      this._isSearching = false;
      this.inputTracker = null;
      this.resetSearchView();
    },
    resetSearchView: function resetSearchView() {
      this.hideResultsView();
    },
    getSearchText: function getSearchText() {
      return this.inputTracker ? this.inputTracker.value() : '';
    },
    triggerSearchText: function triggerSearchText() {
      this.triggerMethod('search:results:text', this.getSearchText());
    },
    hideResultsView: function hideResultsView() {
      this.resultsView.collection = null;
    },
    isResultsEmpty: function isResultsEmpty() {
      return !(this.resultsView.collection && this.resultsView.collection.length);
    }
  });
  channel.reply('tag-input', function () {
    return TagInput;
  });
  return TagInput;
});

